(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-product-card-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  class YGProductCardList extends HTMLElement {
    constructor() {
      super();
      this.initSwiper();
    }

    initSwiper() {
      this.prevBtn = this.querySelector('.swiper-button-prev');
      this.nextBtn = this.querySelector('.swiper-button-next');

      this.swiper = new Swiper(this.querySelector('.swiper'), {
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: "progressbar"
        },
        slidesPerView: 1,
        spaceBetween: 12,
        breakpoints: {
          700:{
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1000: {
            slidesPerView: 4,
            spaceBetween: 16,
          }
        }
      });
    }
  }
  if(!customElements.get('yg-product-card-list')) {
    customElements.define('yg-product-card-list', YGProductCardList);
  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-swiper-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list"] && !Shopify.designMode) return;
  try {
    
  class YGVideoList extends YGUtils {
    constructor() {
      super();
      this.playVideo = this.playVideoFn.bind(this);
      this.currentPlayVideo = null
    }

    get videoList() {
      return this.querySelectorAll('yg-video.yg-video-box');
    }

    get currentVideo() {
      return this.querySelector('.swiper-slide-active yg-video.yg-video-box');
    }

    connectedCallback() {
      this.swiper = this.initSwiper(this);
      this.videoList.forEach(video => {
        video.addEventListener('mouseenter', this.playVideo);
      });
      this.swiper.on('slideChangeTransitionEnd', this.playVideo)
    }

    playVideoFn(event) {
      // event is an Event object, so get the target (yg-video element)
      const video = event.currentTarget || event.target || this.currentVideo;
      
      if (this.currentPlayVideo == video) return;
      this.currentPlayVideo = video
      
      this.videoList.forEach(v => {
        v.pauseVideo();
        if (v) {
          v.closest('.swiper-slide').classList.remove('current-play')
        }
      });

      if (video && typeof video.playVideo === 'function') {
        video.playVideo();
        video.closest('.swiper-slide').classList.add('current-play')
      }
    }
  }
  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList)
  }

  } catch(e) { console.error(e); }
})();
})();
